      document.addEventListener('DOMContentLoaded', function () {
         reinitializeSlickSlider()
        let customerLogin = document.querySelector('body').getAttribute('customer-data') || '';
        if (customerLogin == 'notlogin') {
          let getSections = document.querySelectorAll('.fetch-grid')
          getSections.forEach(section => {
            let collectionHandle = section.dataset.collectionHandle;
            let url = `${window.location.origin}/collections/${collectionHandle}?view=fetch-filters`;
            fetch(url)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const collectionItems = html.querySelectorAll('#collectionContainer li');
                const secGrid = section.querySelector('.home_slider');
                if (secGrid) {
                  secGrid.innerHTML = '';
                }
                collectionItems.forEach((li, index) => {
                  if (secGrid && index < 30) {
                    secGrid.appendChild(li.cloneNode(true));
                  }
                });
                const $slider = $('.home_slider');
                if ($slider.hasClass('slick-initialized')) {
                  $slider.slick('unslick');
                }
                reinitializeSlickSlider();
              })
              .catch((e) => {
                console.error(e);
              });
          })
        }
      });

reinitializeSlickSlider = function reinitializeSlickSlider() {
  $('.home_slider').slick({
    infinite: false,    // Infinite loop
    slidesToShow: 6,   // How many items to show at once
    slidesToScroll: 1, // Scroll 4 items at a time
    autoplay: false,    // Enable autoplay
    autoplaySpeed: 800, // Time between slide transitions (2000ms = 2 seconds)
    speed: 300,        // Speed of transition (2000ms = 2 seconds)
    pauseOnHover: false, // Disable pause on hover
    arrows: true,     // Disable arrows (not needed for slot machine)
    prevArrow: '<button class="slide-arrow prev-arrow"> <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.925737 6.42575C0.774372 6.57851 0.689453 6.78486 0.689453 6.99991C0.689453 7.21497 0.774373 7.42132 0.925737 7.57408L6.3424 12.9907C6.41679 13.0706 6.50649 13.1346 6.60615 13.179C6.70582 13.2234 6.81341 13.2473 6.9225 13.2492C7.0316 13.2511 7.13996 13.2311 7.24113 13.1902C7.34231 13.1493 7.43421 13.0885 7.51136 13.0114C7.58852 12.9342 7.64934 12.8423 7.6902 12.7411C7.73107 12.64 7.75114 12.5316 7.74921 12.4225C7.74729 12.3134 7.72341 12.2058 7.679 12.1062C7.63459 12.0065 7.57056 11.9168 7.49074 11.8424L3.46074 7.81241L14.4999 7.81241C14.7154 7.81241 14.9221 7.72681 15.0744 7.57444C15.2268 7.42206 15.3124 7.2154 15.3124 6.99991C15.3124 6.78443 15.2268 6.57776 15.0744 6.42539C14.9221 6.27302 14.7154 6.18741 14.4999 6.18741L3.46074 6.18741L7.49074 2.15741C7.63426 2.00339 7.71239 1.79967 7.70868 1.58918C7.70496 1.37869 7.61969 1.17786 7.47083 1.02899C7.32196 0.880127 7.12113 0.794856 6.91064 0.791142C6.70014 0.787428 6.49643 0.865561 6.3424 1.00908L0.925737 6.42575Z" fill="white"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"> <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0743 6.42575C15.2256 6.57851 15.3105 6.78486 15.3105 6.99991C15.3105 7.21497 15.2256 7.42132 15.0743 7.57408L9.6576 12.9907C9.58321 13.0706 9.49351 13.1346 9.39385 13.179C9.29418 13.2234 9.18659 13.2473 9.0775 13.2492C8.9684 13.2511 8.86004 13.2311 8.75887 13.1902C8.65769 13.1493 8.56579 13.0885 8.48864 13.0114C8.41148 12.9342 8.35066 12.8423 8.3098 12.7411C8.26893 12.64 8.24886 12.5316 8.25079 12.4225C8.25271 12.3134 8.27659 12.2058 8.321 12.1062C8.36541 12.0065 8.42944 11.9168 8.50926 11.8424L12.5393 7.81241L1.5001 7.81241C1.28461 7.81241 1.07795 7.72681 0.925572 7.57444C0.773199 7.42206 0.687597 7.2154 0.687597 6.99991C0.687597 6.78443 0.773199 6.57776 0.925572 6.42539C1.07795 6.27302 1.28461 6.18741 1.5001 6.18741L12.5393 6.18741L8.50926 2.15741C8.36574 2.00339 8.28761 1.79967 8.29132 1.58918C8.29504 1.37869 8.38031 1.17786 8.52917 1.02899C8.67804 0.880127 8.87887 0.794856 9.08936 0.791142C9.29986 0.787428 9.50357 0.865561 9.6576 1.00908L15.0743 6.42575Z" fill="white"/></svg></button>',
    responsive: [
      {  
        breakpoint: 989,
        settings: {
          slidesToShow: 3 
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]

  });
}




 